export default {
	Chinese: {
		// 关于我们-pc
		aboutUs: {
			introduce: '平台介绍',
			slidingList: ["平台介绍", "荣誉介绍", "简单汇发展历程"],//滑动门数组
			bannerImg:require('@/images/aboutUs/6-1.png'),
			//公司简介
			companyProfile:{
				title:'公司简介',
				CompanyDescription:'数智供应链金融领跑者',
				paragraph1:'简单汇信息科技（广州）有限公司孵化于全球领先的智能科技公司——TCL，是一家数智供应链金融科技服务商，致力于通过科技手段推动商业信用的价值传递，提高企业供应链整体竞争力、降低产业链总成本。简单汇是国家高新技术企业，首批具备上海票据交易所接入资质的科技平台，也是广东省首批供应链金融“监管沙盒”试点企业之一，连续获得欧洲金融陶朱奖、中物联十佳区块链应用企业等荣誉。',
				paragraph2:'源于产业，更懂产业。简单汇具备丰富的实体经验与产业智慧，围绕核心企业产业链，运用大数据、区块链、人工智能、物联网等先进科技手段，搭建出保理云、票据云、跨境云“三朵云”产品，为全国不同行业、背景、供应链主体提供综合供应链金融科技解决方案。'
			},
			//企业使命
			enterpriseMission:{
				title:'企业使命',
				description:'推动商业信用 赋能中小企业',
				paragraph1:'2021年3月5日，政府工作报告提出“创新供应链金融服务模式”，供应链金融已上升为国家战略，其在解决中小微企业融资问题和金融脱实向虚等方面的作用得到了国家层面的认可和扶持。源于产业，更懂产业，简单汇通过市场首创的“金单”产品切实提高中小微企业融资效率，降低企业融资成本。同时，于2020年4月首批直连上海票据交易所实现供应链票据各项功能，加快商业汇票产品规范创新，有效解决中小微企业融资难题。',
				paragraph2:'简单汇以“智慧供应链+金融科技”双轮驱动，坚持通过供应链金融科技创新，为中小微企业提供更加便捷、高效的线上服务，致力于成就简单、温暖的产业金融，受到中国人民银行、上海票据交易所及众多金融机构、企业的高度肯定。',
				paragraph3:'未来，简单汇还将与更多掌握全球高水平技术的高校、院所、企事业单位以及各类银行、金融机构进行深度合作，围绕核心企业产业链，运用大数据、区块链、人工智能等先进科技手段，为供应链企业提供方便、快捷、优惠的综合金融解决方案，共同解决技术难题，积极推动供应链金融的高质量发展。'
			},
			//价值观
			 values:{
				 title:'价值观',
				 description:'简单温暖，专业高效',
				 paragraphtitleOne:'不忘初心，简单坚守',
				 paragraphOne:'简单汇自诞生之日起坚持不碰资金，只做科技。经过多年运营，简单汇的业务模式已获得包括行业专家、律师事务所、金融机构、监管机构、行业协会及超过百家上市公司的认可与好评，树立了正直的企业形象。',
				 paragraphtitleTwo:'创新图变，奋楫争先',
				 paragraphTwo:'简单汇坚持供应链金融科技创新，重磅推出多项全国首创金融科技服务，包括首张应收账款电子债权凭证、首张供应链票据、首次将区块链与凭证业务结合、首单不特定原始权益人ABS储架发行等。简单汇多次实现“从0到1”的突破，始终走在供应链金融科技前沿。',
				 paragraphtitleThree:'专业精进，普惠小微',
				 paragraphThree:'凭借专业的科技能力，简单汇开系统直连银行之先河，与市场头部金融机构深度合作，也是首批直连上海票据交易所的金融科技公司之一。平台不碰资金，专注第三方信息科技服务，降低运行风险，保障资金的安全性；深耕电气制造、电子制造、通用设备、建筑、化工、农业等各类产业，以产业智慧赋能供应链金融，为数万家中小微企业引入金融活水，推出的智慧供应链金融科技解决方案已成功在多个大型产业生态中得到广泛验证。'
			 },
			 //荣誉介绍
			 honors:{
				title:'荣誉介绍',
				honorList: [
					{
						imagePath: require("@/images/aboutUs/img_awards_1.png")
					},
					{
						imagePath: require("@/images/aboutUs/img_awards_2.png")
					},
					{
						imagePath: require("@/images/aboutUs/img_awards_3.png")
					},
					{
						imagePath: require("@/images/aboutUs/img_awards_4.png")
					},
					{
						imagePath: require("@/images/aboutUs/img_awards_5.png")
					},
					{
						imagePath: require("@/images/aboutUs/img_awards_6.png")
					},
					{
						imagePath: require("@/images/aboutUs/img_awards_7.png")
					}
				],
			 },

			 //发展历程
			 timeline:{
				 title:'简单汇发展历程'
			 },
			 //办公地点
			 officeLocation:{
				 title:'业务分布'
			 }
		},
		// 关于我们-移动端中文
		aboutUsPhone:{
			//banner
			bannerImg:require('@/images/mobile/aboutUs/1-0.png'),
			//公司简介
			companyProfile:{
				title:'公司简介',
				CompanyDescription:'数智供应链金融领跑者',
				paragraph1:'简单汇信息科技（广州）有限公司孵化于全球领先的智能科技公司——TCL，是一家数智供应链金融科技服务商，致力于通过科技手段推动商业信用的价值传递，提高企业供应链整体竞争力、降低产业链总成本。简单汇是国家高新技术企业，首批具备上海票据交易所接入资质的科技平台，也是广东省首批供应链金融“监管沙盒”试点企业之一，连续获得欧洲金融陶朱奖、中物联十佳区块链应用企业等荣誉。',
				paragraph2:'源于产业，更懂产业。简单汇具备丰富的实体经验与产业智慧，围绕核心企业产业链，运用大数据、区块链、人工智能、物联网等先进科技手段，搭建出保理云、票据云、跨境云“三朵云”产品，为全国不同行业、背景、供应链主体提供综合供应链金融科技解决方案。'
			},
			//企业使命
			enterpriseMission:{
				title:'企业使命',
				description:'推动商业信用 赋能中小企业',
				paragraph1:'2021年3月5日，政府工作报告提出“创新供应链金融服务模式”，供应链金融已上升为国家战略，其在解决中小微企业融资问题和金融脱实向虚等方面的作用得到了国家层面的认可和扶持。源于产业，更懂产业，简单汇通过市场首创的“金单”产品切实提高中小微企业融资效率，降低企业融资成本。同时，于2020年4月首批直连上海票据交易所实现供应链票据各项功能，加快商业汇票产品规范创新，有效解决中小微企业融资难题。',
				paragraph2:`简单汇以“智慧供应链+金融科技”双轮驱动，坚持通过供应链金融科技创新，为中小微企业提供更加便捷、高效的线上服务，致力于成就简单、温暖的产业金融，受到中国人民银行、上海票据交易所及众多金融机构、企业的高度肯定。`,
				paragraph3:`未来，简单汇还将与更多掌握全球高水平技术的高校、院所、企事业单位以及各类银行、金融机构进行深度合作，围绕核心企业产业链，运用大数据、区块链、人工智能等先进科技手段，为供应链企业提供方便、快捷、优惠的综合金融解决方案，共同解决技术难题，积极推动供应链金融的高质量发展。`
			},
			//价值观
			 values:{
				 title:'价值观',
				 description:'简单温暖，专业高效',
				 paragraphtitleOne:'不忘初心，简单坚守',
				 paragraphOne:'简单汇自诞生之日起坚持不碰资金，只做科技。经过多年运营，简单汇的业务模式已获得包括行业专家、律师事务所、金融机构、监管机构、行业协会及超过百家上市公司的认可与好评，树立了正直的企业形象。',
				 paragraphtitleTwo:'创新图变，奋楫争先',
				 paragraphTwo:'简单汇坚持供应链金融科技创新，重磅推出多项全国首创金融科技服务，包括首张应收账款电子债权凭证、首张供应链票据、首次将区块链与凭证业务结合、首单不特定原始权益人ABS储架发行等。简单汇多次实现“从0到1”的突破，始终走在供应链金融科技前沿。',
				 paragraphtitleThree:'专业精进，普惠小微',
				 paragraphThree:`凭借专业的科技能力，简单汇开系统直连银行之先河，与市场头部金融机构深度合作，也是首批直连上海票据交易所的金融科技公司之一。平台不碰资金，专注第三方信息科技服务，降低运行风险，保障资金的安全性；深耕电气制造、电子制造、通用设备、建筑、化工、农业等各类产业，以产业智慧赋能供应链金融，为数万家中小微企业引入金融活水，
					推出的智慧供应链金融科技解决方案已成功在多个大型产业生态中得到广泛验证。`
			 },
			 //荣誉介绍
			honors:{
				title:'荣誉介绍',
				carouselList: [{
          imagePath: require("@/images/aboutUs/img_awards_1.png")
        },
        {
          imagePath: require("@/images/aboutUs/img_awards_2.png")
        },
        {
          imagePath: require("@/images/aboutUs/img_awards_3.png")
        },
        {
          imagePath: require("@/images/aboutUs/img_awards_4.png")
        },
        {
          imagePath: require("@/images/aboutUs/img_awards_5.png")
        },
        {
          imagePath: require("@/images/aboutUs/img_awards_6.png")
        },
        {
          imagePath: require("@/images/aboutUs/img_awards_7.png")
        }],
			},
			//发展历程
			timeline:{
			 	title:'简单汇发展历程'
			},
		}
	},
	English: {
		// 关于我们-pc
		aboutUs: {
			introduce: 'Platform introduction',
			slidingListYW: ["Platform introduction","Honors","JDH Timeline"],
			bannerImg:require('@/images/english/banner_aboutus.png'),
			//公司简介
			companyProfile:{
				title:'companyProfile',
				CompanyDescription:'A Leader in Digital-Intelligent Supply Chain Finance',
				paragraph1:`JDH Information Technology (Guangzhou) Co., Ltd., incubated by the World's Leading AI & Smart Technology Company ——TCL, is a digital and intelligent supply chain financial technology service provider. The company aims to enhance the overall competitiveness of corporate supply chains and reduce the total cost of the industrial chain by leveraging technological means to promote the value transmission of commercial credit. JDH is a Chinese national high-tech enterprise, one of the first technology platforms to gain access to the Shanghai Commercial Paper Exchange, and one of the first pilot enterprises in Guangdong Province for the supply chain finance 'regulatory sandbox.' It has received numerous accolades, including the European Financial Tao Zhu Award and the Top Ten Blockchain Application Enterprise by China Federation of Logistics and Purchasing.`,
				paragraph2:`Industry-Grown, Industry-Savvy. JDH, with its extensive physical experience and industry insights, focuses on the anchor enterprise's industrial chain. By leveraging advanced technologies such as big data, blockchain, AI, and IoT, we have developed three cloud products: Factoring Cloud, Bill Cloud, and Cross-border Cloud. These products offer comprehensive supply chain financial technology solutions to entities across various industries, backgrounds, and supply chains nationwide.`
			},
			//企业使命
			enterpriseMission:{
				title:'Mission',
				description:'Improve commercial credit and empower SMEs',
				paragraph1:'On March 5, 2021, the “innovative supply chain financial service model” was mentioned in the government work report. Supply chain finance has become a national strategy, and its role in solving the financing problems faced by MSMEs and financial detachment has been recognized and supported at the national level. With a great wealth of experience from industry supply chain ,JDH is deriving from the real industry, understands the industry better, effectively improves the financing efficiency of MSMEs and reduces the financing costs of enterprises through the “JinBill” products pioneered by the market. In addition, JDH was the first batch of platform directly connected to Shanghai Commercial Paper Exchange Corporation Ltd. to realize the various functions of supply chain bills in April 2020, which accelerated the standardization innovation of commercial bill products, and effectively solved the financing problems of MSMEs.',
				paragraph2:`With Smart SCM & FinTech as dual catalysts, we are redefining supply chain finance through technological innovation. JDH insist on providing more convenient and efficient online services for micro, small and medium-sized enterprises through innovation of supply chain financial technology, and is committed to achieving simple and warm industrial finance. It has been highly recognized by the People's Bank of China,Shanghai Commercial Paper Exchange and many financial institutions and enterprises.`,
				paragraph3:'In the future, JDH will also conduct in-depth cooperation with more universities, institutes, enterprises and institutions with high-level technology, as well as various banks and financial institutions in the world. Focusing on the core enterprise industrial chain, JDH will utilize advanced scientific and technological means such as big data, blockchain and artificial intelligence to provide convenient, fast, preferential and comprehensive financial solutions for supply chain enterprises and jointly solve technical problems, thus actively promoting the high-quality development of supply chain finance.'
			},
			//价值观
			 values:{
				 title:'Values',
				 description:'Simple, warm, professional and efficient',
				 paragraphtitleOne:'Remain true to the original aspiration, and simply stick to',
				 paragraphOne:'Since its establishment, JDH has focused on scientific and technological development instead of financial service. After years of operation, JDH has been recognized and praised by industry experts, law firms, financial institutions, regulatory agencies, industry associations and over 100 listed companies in its business model, thus establishing an honest corporate image.',
				 paragraphtitleTwo:'Innovation, and vigorous efforts to move forward ',
				 paragraphTwo:'JDH insists on the innovation of supply chain financial technology, and has initiated many national financial technology services, including the first electronic creditor’s right certificate for accounts receivable, the first supply chain bill, the first combination of blockchain and voucher business, and the first issuance of ABS refinancing system for the unspecified primary stakeholder. Besides, JDH has achieved a breakthrough from 0 to 1 many times so as to take the lead in supply chain financial technology.',
				 paragraphtitleThree:'Professional diligence, and inclusive SME',
				 paragraphThree:`JDH initiated the direct connection between the system and banks and closely cooperated with the leading financial institutions in the market by virtue of its professional scientific and technological capabilities. In addition, it is also one of the first batch of financial technology companies directly connected to Shanghai Commercial Paper Exchange Corporation Ltd. The JDH platform can reduce operational risks and ensure the security of funds by focusing on third-party information technology services instead of funds.
								JDH has extensive experience in serving a variety of industries, such as electrical and electronic manufacturing, general equipment, construction, chemical engineering ,agriculture and other industries , thus empowering supply chain finance with its industrial serving experience and introducing finance to thousands of SME .The smart supply chain Fintech solution launched by JDH has been successfully and widely verified in many large-scale industrial ecology.`
			 },
			 //荣誉介绍
			 honors:{
			 	title:'Honors',
				honorListYW: [
					{
						imagePath: require("@/images/english/img_awards_1en.png")
					},
					{
						imagePath: require("@/images/english/img_awards_2en.png")
					},
					{
						imagePath: require("@/images/english/img_awards_3en.png")
					},
					{
						imagePath: require("@/images/english/img_awards_4en.png")
					},
					{
						imagePath: require("@/images/english/img_awards_5en.png")
					},
					{
						imagePath: require("@/images/english/img_awards_6en.png")
					},
					{
						imagePath: require("@/images/english/img_awards_7en.png")
					}
				],
			},
			 //发展历程
			 timeline:{
			 	title:'JDH Timeline'
			 },
			 //办公地点
			 officeLocation:{
			 	title:'Business Spread'
			 }
		},
		// 关于我们-移动端英文
		aboutUsPhone:{
			//banner
			bannerImg:require('@/images/mobile/english/banner_aboutus.png'),
			//公司简介
			companyProfile:{
				title:'companyProfile',
				CompanyDescription:'A Leader in Digital-Intelligent Supply Chain Finance',
				paragraph1:`JDH Information Technology (Guangzhou) Co., Ltd., incubated by the World's Leading AI & Smart Technology Company ——TCL, is a digital and intelligent supply chain financial technology service provider. The company aims to enhance the overall competitiveness of corporate supply chains and reduce the total cost of the industrial chain by leveraging technological means to promote the value transmission of commercial credit. JDH is a Chinese national high-tech enterprise, one of the first technology platforms to gain access to the Shanghai Commercial Paper Exchange, and one of the first pilot enterprises in Guangdong Province for the supply chain finance 'regulatory sandbox.' It has received numerous accolades, including the European Financial Tao Zhu Award and the Top Ten Blockchain Application Enterprise by China Federation of Logistics and Purchasing.`,
				paragraph2:`Industry-Grown, Industry-Savvy. JDH, with its extensive physical experience and industry insights, focuses on the anchor enterprise's industrial chain. By leveraging advanced technologies such as big data, blockchain, AI, and IoT, we have developed three cloud products: Factoring Cloud, Bill Cloud, and Cross-border Cloud. These products offer comprehensive supply chain financial technology solutions to entities across various industries, backgrounds, and supply chains nationwide.`
			},
			//企业使命
			enterpriseMission:{
				title:'Mission',
				description:'Improve commercial credit and empower SMEs',
				paragraph1:`On March 5, 2021, the “innovative supply chain financial service model” was mentioned in the government work report. Supply chain finance has become a national strategy, and its role in solving the financing problems faced by MSMEs and financial detachment has been recognized and supported at the national level.
With a great wealth of experience from industry supply chain ,JDH is deriving from the real industry, understands the industry better, effectively improves the financing efficiency of MSMEs and reduces the financing costs of enterprises through the “JinBill” products pioneered by the market. In addition, JDH was the first batch of platform directly connected to Shanghai Commercial Paper Exchange Corporation Ltd. to realize the various functions of supply chain bills in April 2020, which accelerated the standardization innovation of commercial bill products, and effectively solved the financing problems of MSMEs.`,
				paragraph2:`With Smart SCM & FinTech as dual catalysts, we are redefining supply chain finance through technological innovation. JDH insist on providing more convenient and efficient online services for micro, small and medium-sized enterprises through innovation of supply chain financial technology, and is committed to achieving simple and warm industrial finance. It has been highly recognized by the People's Bank of China,Shanghai Commercial Paper Exchange and many financial institutions and enterprises.`,
				paragraph3:`In the future, JDH will also conduct in-depth cooperation with more universities, institutes, enterprises and institutions with high-level technology, as well as various banks and financial institutions in the world. Focusing on the core enterprise industrial chain, JDH will utilize advanced scientific and technological means such as big data, blockchain and artificial intelligence to provide convenient, fast, preferential and comprehensive financial solutions for supply chain enterprises and jointly solve technical problems, thus actively promoting the high-quality development of supply chain finance.`
			},
			//价值观
			 values:{
				 title:'Values',
				 description:'Simple, warm, professional and efficient',
				 paragraphtitleOne:'Remain true to the original aspiration, and simply stick to',
				 paragraphOne:'Since its establishment, JDH has focused on scientific and technological development instead of financial service. After years of operation, JDH has been recognized and praised by industry experts, law firms, financial institutions, regulatory agencies, industry associations and over 100 listed companies in its business model, thus establishing an honest corporate image.',
				 paragraphtitleTwo:'Innovation, and vigorous efforts to move forward',
				 paragraphTwo:`JDH insists on the innovation of supply chain financial technology, and has initiated many national financial technology services, including the first electronic creditor’s right certificate for accounts receivable, the first supply chain bill, the first combination of blockchain and voucher business, and the first issuance of ABS refinancing system for the unspecified primary stakeholder. Besides,
					JDH has achieved a breakthrough from 0 to 1 many times so as to take the lead in supply chain financial technology.`,
				 paragraphtitleThree:'Professional diligence, and inclusive SME',
				 paragraphThree:`JDH initiated the direct connection between the system and banks and closely cooperated with the leading financial institutions in the market by virtue of its professional scientific and technological capabilities. In addition, it is also one of the first batch of financial technology companies directly connected to Shanghai Commercial Paper Exchange Corporation Ltd. The JDH platform can reduce operational risks and ensure the security of funds by focusing on third-party information technology services instead of funds. JDH has extensive experience in serving a variety of industries, such as electrical and electronic manufacturing, general equipment, construction, chemical engineering ,agriculture and other industries , thus empowering supply chain finance with its industrial serving experience and introducing finance to thousands of SME .
					The smart supply chain Fintech solution launched by JDH has been successfully and widely verified in many large-scale industrial ecology.`
			 },
			 //荣誉介绍
			honors:{
				title:'Honors',
				carouselListYW: [
            {
              imagePath: require("@/images/english/img_awards_1en.png")
            },
            {
              imagePath: require("@/images/english/img_awards_2en.png")
            },
            {
              imagePath: require("@/images/english/img_awards_3en.png")
            },
            {
              imagePath: require("@/images/english/img_awards_4en.png")
            },
            {
              imagePath: require("@/images/english/img_awards_5en.png")
            },
            {
              imagePath: require("@/images/english/img_awards_6en.png")
            },
            {
              imagePath: require("@/images/english/img_awards_7en.png")
            }
				],
			},
			//发展历程
			timeline:{
				title:'JDH Timeline'
			},
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/lang/aboutUs.js